export * from './MathDeltaIcon';
export * from './MathDeltaIcon16Light';
export * from './MathDeltaIcon16Regular';
export * from './MathDeltaIcon16Solid';
export * from './MathDeltaIcon20Light';
export * from './MathDeltaIcon20Regular';
export * from './MathDeltaIcon20Solid';
export * from './MathDeltaIcon24Regular';
export * from './MathDeltaIcon24Solid';
export * from './MathDeltaIcon32Regular';
export * from './MathDeltaIcon64Regular';
